import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { ErrorBoundary } from "../components/ErrorBoundary";
import FallBackUI from "../components/FallBackUI";
import SuspenseWrapper from "../components/SuspenseWrapper";
import LanguageContextWrapper from "../context/Language/LanguageContextWrapper";
import Footer from "./Footer";
import Navbar from "./Navbar";
import { LogoProvider } from "@/context/LogoContext";

const MainLayout = () => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [location]);
  return (
    <LanguageContextWrapper>
      <LogoProvider>
        <div className="flex flex-col overflow-x-hidden">
          <Navbar />
          <div className="min-h-[calc(100vh-22.5rem)]" role="main">
            <ErrorBoundary fallback={<FallBackUI />}>
              <SuspenseWrapper children={<Outlet />} />
            </ErrorBoundary>
          </div>
          <Footer />
        </div>
      </LogoProvider>
    </LanguageContextWrapper>
  );
};

export default MainLayout;
